import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { API } from "../../Redux/actions/API";
import { useDispatch, useSelector } from "react-redux";

function Navbar() {
  const history = useNavigate();
  const handleLogout = () => {
    localStorage.clear();
    history("/");
    window.location.reload();
  };

  const { userId, username, jwt_token } = useSelector((state) => state.Auth);
  const uid = userId;
  //console.log("hhhj", username);
  const [menulist, setmenulist] = useState([]);
  const [submenulist, setsubmenulist] = useState([]);

  const MenuList = async () => {
    try {
      let res = await API?.post(
        "/bindLayout",
        {
          username: uid,
          uid: username,
          type: "SubAdminList",
          mainid: "",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      //console.log("sss_menu", res?.data?.data);
      setmenulist(res?.data?.data);
    } catch (e) {
      if (e.response.status === 401) {
        handleLogout();
      } else {
        console.log("error Balance APi", e);
      }
    }
  };

  const SubMenuList = async () => {
    try {
      let res = await API?.post(
        "/bindLayout",
        {
          username: uid,
          uid: username,
          type: "main_react",
          mainid: "",
        },
        {
          headers: {
            Authorization: jwt_token,
          },
        },
      );
      console.log("sss_submenu", res?.data);
      setsubmenulist(res?.data?.data);
    } catch (e) {
      if (e.response.status === 401) {
      } else {
        console.log("error Balance APi", e);
      }
    }
  };

  // useEffect(() => {
  //   MenuList();
  //   SubMenuList();
  // }, []);

  return (
    <div>
      {/* <!-- Top Bar Start --> */}
      <div className="topbar">
        {/* <!-- LOGO --> */}
        <div className="topbar-left">
          <div className="text-center">
            <a href="#" className="logo">
              <img
                src="/assets/images/logo.png"
                style={{ width: "60px", height: "auto" }}
              />{" "}
            </a>
          </div>
        </div>
        {/* <!-- Button mobile view to collapse sidebar menu --> */}
        <div className="navbar navbar-default" role="navigation">
          <div className="container">
            <div className="">
              <div className="pull-left">
                <button
                  className="button-menu-mobile open-left"
                  type="button"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasExample"
                  aria-controls="offcanvasExample"
                >
                  <i className="fa fa-bars"></i>
                </button>
                <div
                  className="offcanvas offcanvas-start"
                  tabindex="-1"
                  id="offcanvasExample"
                  aria-labelledby="offcanvasExampleLabel"
                >
                  <div className="offcanvas-body pp-ip-pro">
                    <div className="topbar-left-1">
                      <div className="text-center">
                        <a href="#" className="logo">
                          <img
                            src="/assets/images/logo.png"
                            style={{ height: "45px", width: "50%" }}
                          />{" "}
                        </a>
                      </div>
                    </div>
                    <div className="left side-menu">
                      <div className="slimScrollDiv">
                        <div className="sidebar-inner slimscrollleft">
                          <div className="user-details">
                            <div className="pull-left">
                              <img
                                src="assets/images/avatar-1.jpg"
                                alt=""
                                className="thumb-md img-circle"
                              />
                            </div>
                            <div className="user-info">
                              <div className="dropdown">
                                <a
                                  href="#"
                                  className="dropdown-toggle"
                                  data-toggle="dropdown"
                                  aria-expanded="false"
                                >
                                  <label id="lblname">Admin</label>
                                  {/* <span className="caret"></span> */}
                                </a>
                                <ul className="dropdown-menu">
                                  <li>
                                    <a href="/" onClick={() => handleLogout()}>
                                      <i className="md md-settings-power"></i>{" "}
                                      Logout
                                    </a>
                                  </li>
                                </ul>
                              </div>
                              <p className="text-muted m-0">Administrator</p>
                            </div>
                          </div>
                          {/* <!--- Divider --> */}
                          <div id="sidebar-menu">
                            <ul
                              className="accordion accordion-flush"
                              id="accordionFlushExample"
                            >
                              {/* 
                              {menulist?.map((item, index) => {
                                return (
                                  <>
                                    <li className="has_sub" key={item.id}>
                                      <a
                                        className="waves-effect"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#flush-collapse${item.id}`}
                                        aria-expanded="false"
                                        aria-controls={`flush-collapse${item.id}`}
                                      >
                                        <i className="md md-account-box"></i>
                                        <span>{item.Name}</span>
                                      </a>

                                      <div
                                        id={`flush-collapse${item.id}`}
                                        className="accordion-collapse collapse"
                                        aria-labelledby="flush-heading1"
                                        data-bs-parent="#accordionFlushExample"
                                      >
                                        {submenulist.map((litem, lindex) => {
                                          return (
                                            <>
                                              {item.id === litem.main_manu ? (
                                                <div
                                                  className="accordion-body"
                                                  key={litem.id}
                                                >
                                                  <li>
                                                    <a
                                                      className="waves-effect waves-effect-1"
                                                      href={litem.link}
                                                    >
                                                      {litem.submenu}
                                                    </a>
                                                  </li>
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          );
                                        })}
                                      </div>
                                    </li>
                                  </>
                                );
                              })}*/}
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse1"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse1"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Dashboard</span>
                                </a>

                                <div
                                  id="flush-collapse1"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Dashboard"
                                      >
                                        Dashboard
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse2"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse2"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Member</span>
                                </a>

                                <div
                                  id="flush-collapse2"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Member_Details"
                                      >
                                        All Member
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/ActiveMember"
                                      >
                                        Active Members
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Commission_Report"
                                      >
                                        Inactive Members
                                      </a>
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/RoiRate"
                                      >
                                        Update Roi Rate
                                      </a> */}

                                      {/*<a
                                        className="waves-effect waves-effect-1"
                                        href="/RetopupHistory"
                                      >
                                        Upgrade Member
                                      </a>*/}
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/LimitOver"
                                      >
                                        Income Limit Summary
                                      </a> */}
                                    </li>
                                  </div>
                                </div>
                              </li>
                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse3"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse3"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Task</span>
                                </a>

                                <div
                                  id="flush-collapse3"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/TaskEntry"
                                      >
                                        Add Task
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/TaskHistory"
                                      >
                                        Task History
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/UserTaskHistory"
                                      >
                                        User Task History
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/UserTaskHistoryNew"
                                      >
                                        Task List User History
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse3"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse3"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Trading</span>
                                </a>

                                <div
                                  id="flush-collapse3"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/NewCoin"
                                      >
                                        Add New Coin
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/CoinRateUpdate"
                                      >
                                        Update Coin Rate with Time
                                      </a>
                                    </li>
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/CoinRateUpdateHistory"
                                      >
                                        Coin Rate with Time History
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse31"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse31"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Activation</span>
                                </a>

                                <div
                                  id="flush-collapse31"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/BotActivation"
                                      >
                                        Bot Activate User Id
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Activation"
                                      >
                                        Activate / Upgrade User Id
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Activationhistory"
                                      >
                                        Admin Activation/Upgrade History
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/userActivationhistory"
                                      >
                                        User Activation/Upgrade History
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne24"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne24"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Add QR</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne24"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/UsdtqrDetails"
                                      >
                                        QR Details
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/PendingQRRequest"
                                      >
                                        Pending Trading Fund Request
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/qrHistory"
                                      >
                                        Paid Trading Fund History
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseSixOne241"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseSixOne241"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Registration Fees</span>
                                </a>

                                <div
                                  id="flush-collapseSixOne241"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-headingSixOne"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/PendingAcivation"
                                      >
                                        Pending Registration Fees Request
                                      </Link>
                                    </li>
                                    <li>
                                      <Link
                                        className="waves-effect waves-effect-1"
                                        to="/ActivationHistory"
                                      >
                                        Paid Registration Fees Request
                                      </Link>
                                    </li>
                                  </div>
                                </div>
                              </li>

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse15"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse15"
                                >
                                  <i className="md md-account-box"></i>
                                  <span> Fund</span>
                                </a>

                                <div
                                  id="flush-collapse15"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/activationfund"
                                      >
                                        Transfer Trading Fund
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/deductactivationfund"
                                      >
                                        Deduct Trading Fund
                                      </a>

                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/IncometoFundHis"
                                      >
                                        Income to Fund Convert History
                                      </a> */}
                                    </li>
                                  </div>
                                </div>
                              </li>

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse4"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse4"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>My Team</span>
                                </a>

                                <div
                                  id="flush-collapse4"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/myreferrals"
                                      >
                                        My Referral
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/My_Team"
                                      >
                                        My Team
                                      </a>
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/levelDetails"
                                      >
                                        Level Detail
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/DirectLegBusiness"
                                      >
                                        Direct Leg Business
                                      </a> */}
                                    </li>
                                  </div>
                                </div>
                              </li>

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse5"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse5"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Income</span>
                                </a>

                                <div
                                  id="flush-collapse5"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/Total_incomeReport"
                                      >
                                        Total Income Report
                                      </a> */}
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/Direct_Income"
                                      >
                                        Refferal Income
                                      </a> */}
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/ReferralLevelIncome"
                                      >
                                        Referral Level Income
                                      </a> */}
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/BinaryIncome"
                                      >
                                        Binary Income
                                      </a>
                                     
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/LevelIncome"
                                      >
                                        Roi Level Income
                                      </a> */}
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/Club_Income"
                                      >
                                      CTO income
                                      </a> */}
                                      {/* <a
                                        className="waves-effect waves-effect-1"
                                        href="/RoiIncome"
                                      >
                                        ROI Income
                                      </a> */}
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/RankQualify"
                                      >
                                        Add User Rank
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/TeamReward_income"
                                      >
                                        User Rank History
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/AddSalaryFund"
                                      >
                                        Add Salary Income
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Salary_Income"
                                      >
                                        Salary Income
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/IncentiveIncome"
                                      >
                                        Incentive Income
                                      </a>

                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/RewardIncome"
                                      >
                                        Reward income
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li>

                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse5"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse5"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Bonus</span>
                                </a>

                                <div
                                  id="flush-collapse5"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      
                                    </li>
                                  </div>
                                </div>
                              </li> */}

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse6"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse6"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Withdrawal</span>
                                </a>

                                <div
                                  id="flush-collapse6"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Pending_Withdrawal"
                                      >
                                        BEP(20) Pending Withdrawal
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Pending_Withdrawal_Tron"
                                      >
                                        Bank Pending Withdrawal
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Withdrawal_History"
                                      >
                                        Withdrawal History
                                      </a>
                                    </li>
                                    {/* <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/PendingClaimCapitalWithdrawal"
                                      >
                                        Pending Claim Capital Withdrawal
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/PaidClaimCapitalWithdrawal"
                                      >
                                        Paid Claim Capital Withdrawal
                                      </a>
                                    </li> */}
                                    {/* <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/ComPending_Withdrawal"
                                      >
                                        Compound Pending Withdrawal
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/ComWithdrawal_History"
                                      >
                                        Compound Withdrawal History
                                      </a>
                                    </li> */}
                                  </div>
                                </div>
                              </li>

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse7"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse7"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>HelpDesk</span>
                                </a>

                                <div
                                  id="flush-collapse7"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/HelpDesk"
                                      >
                                        View Helpdesk Open Query
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/ClosedHelpDesk"
                                      >
                                        View Helpdesk Close Query
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li>
                              {/* 
                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse8"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse8"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Sub Admin</span>
                                </a>

                                <div
                                  id="flush-collapse8"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Manage_subadmin"
                                      >
                                        Manage SubAdmin
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/Subadmin_rights"
                                      >
                                        SubAdmin Rights
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/SubadminHistory"
                                      >
                                        SubAdmin Rights History
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse9"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse9"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Manage News</span>
                                </a>

                                <div
                                  id="flush-collapse9"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/News"
                                      >
                                        Manage News
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li>

                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse10"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse10"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Zero Pin Activation</span>
                                </a>

                                <div
                                  id="flush-collapse10"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/zeropinA"
                                      >
                                        Zero Pin Activation
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/zeropinAHistory"
                                      >
                                        Zero Pin Activation History
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}

                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse11"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse11"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Roi Zero Pin Activation History </span>
                                </a>

                                <div
                                  id="flush-collapse11"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/RoizeropinAHistory	"
                                      >
                                        Roi Zero Pin Activation History
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/zeropinAHistory"
                                      >
                                        Zero Pin Activation History
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}

                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse12"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse12"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Income Deduction</span>
                                </a>

                                <div
                                  id="flush-collapse12"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/incomededuct	"
                                      >
                                        Income Deduct
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/incomededucthis	"
                                      >
                                        Income Deduct History
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/incomeflushhis	"
                                      >
                                        Retopup Flush Income
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}

                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse14"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse14"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Power Leg</span>
                                </a>

                                <div
                                  id="flush-collapse14"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/addpower"
                                      >
                                        Power Leg
                                      </a>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/powerhistory		"
                                      >
                                        Power Leg History
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}

                              {/* <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapse16"
                                  aria-expanded="false"
                                  aria-controls="flush-collapse16"
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Business Summary</span>
                                </a>

                                <div
                                  id="flush-collapse16"
                                  className="accordion-collapse collapse"
                                  aria-labelledby="flush-heading1"
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <li>
                                      <a
                                        className="waves-effect waves-effect-1"
                                        href="/BusinessSummary"
                                      >
                                        Business Summary
                                      </a>
                                    </li>
                                  </div>
                                </div>
                              </li> */}

                              <li className="has_sub">
                                <a
                                  className="waves-effect"
                                  type="button"
                                  data-bs-toggle="collapse"
                                  data-bs-target="#flush-collapseTen"
                                  aria-expanded="false"
                                  aria-controls="flush-collapseTen"
                                  href="/"
                                  onClick={() => handleLogout()}
                                >
                                  <i className="md md-account-box"></i>
                                  <span>Log-Out</span>
                                </a>
                              </li>
                            </ul>
                            <div className="clearfix"></div>
                            <div className="clearfix"></div>
                          </div>
                        </div>
                        <div
                          className="slimScrollBar"
                          style={{
                            background: "rgb(122, 134, 143)",
                            width: "5px",
                            position: "absolute",
                            top: "0px",
                            opacity: "0.4",
                            display: "none",
                            borderRadius: "7px",
                            zIndex: "99",
                            right: "1px",
                            height: "1305px",
                            visibility: "visible",
                          }}
                        ></div>
                        <div
                          className="slimScrollRail"
                          style={{
                            width: "5px",
                            height: "100%",
                            position: "absolute",
                            top: "0px",
                            display: "none",
                            borderadius: "7px",
                            background: "rgb(51, 51, 51)",
                            opacity: "0.2",
                            zIndex: "90",
                            right: "1px",
                          }}
                        ></div>
                      </div>
                      {/* <!-- Left Sidebar End --> */}
                    </div>
                  </div>
                </div>
                <span className="clearfix"></span>
              </div>
              <ul className="nav navbar-nav navbar-right pull-right">
                <li className="dropdown pp-pro">
                  <a
                    href="#"
                    className="dropdown-toggle profile"
                    data-toggle="dropdown"
                    aria-expanded="true"
                  >
                    <img
                      src="assets/images/avatar-1.jpg"
                      alt="user-img"
                      className="img-circle"
                    />
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <a href="/" onClick={() => handleLogout()}>
                        <i className="md md-settings-power"></i> Logout
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            {/* <!--/.nav-collapse --> */}
          </div>
        </div>
      </div>
      {/* <!-- Top Bar End --> */}
    </div>
  );
}

export default Navbar;
